import React from 'react';

export default function QuickStockCountTable() {
	return (
		<div className="table-view table-responsive">
			<table id="sales-quotes-charge-table" className="table">
				<thead>
					<tr>
						<th>Warehouse</th>
						<th>Product Code</th>
						<th>Product Description</th>
						<th>Bin Location</th>
						<th>Unit Of Measure</th>
						<th>Pack Size</th>
						<th>On HandQuantity</th>
					</tr>
				</thead>
				<tbody></tbody>
			</table>
		</div>
	);
}
